import { TraceableProcess, TrackingEvent } from '../../../../services/analytics/model';

export class FooterClickedEvent implements TrackingEvent {
  public readonly action = 'Footer Clicked';
  public readonly category = TraceableProcess.NAVIGATION;
  public readonly label = `label = ${this.labelFooter}, labelFooter = ${this.labelFooter}`;

  constructor(public readonly labelFooter: string) {}
}
